import type { Security } from '@ipfabric/utils';
import { getReferenceDictionaries } from 'components/SecuritySchema/model/helpers/getReferenceDictionaries';
import type { SecurityNodeResolutionScope } from 'components/SecuritySchema/model/helpers/securitySchemaNodeFromTest';

export const dereferenceValue =
  (resolutionScope: SecurityNodeResolutionScope) =>
  (value: Security.ReferencedValue): Security.LiteralValue | undefined =>
    getReferenceDictionaries(
      resolutionScope.deviceSecurity,
      resolutionScope.type,
      value.reference.dictionary,
    ).namedValues?.[value.reference.type]?.[value.reference.key];
